import type { Meta, StoryFn } from '@storybook/react';

import { CaseView } from '@pega/cosmos-react-work';

import { AppShellDemo } from '../../core/AppShell/AppShell.stories';

import { CaseViewMock } from './CaseView.mocks';
import type { CaseViewMockProps } from './CaseView.mocks';

export default {
  title: 'Work/CaseView',
  component: CaseView,
  parameters: {
    layout: 'fullscreen'
  }
} as Meta;

export const CaseViewDemo: StoryFn<CaseViewMockProps> = (args: CaseViewMockProps) => {
  return (
    <AppShellDemo
      appHeader
      main={
        <CaseViewMock
          {...args}
          caseId={args.caseId}
          icon={args.icon}
          heading={args.heading}
          subheading={args.subheading}
          summaryFields={args.summaryFields}
          stages={args.stages}
          tasks={args.tasks}
          taskCount={args.taskCount}
          parentCases={args.parentCases}
          predictions={args.predictions}
          attachments={args.attachments}
          stakeholders={args.stakeholders}
          casehierarchy={args.casehierarchy}
          followers={args.followers}
          tags={args.tags}
          persistentUtility={args.persistentUtility}
          banner={args.banner}
          promotedActions={args.promotedActions}
          headingLength={args.headingLength}
          enableGenAICoach={args.enableGenAICoach}
          showGenAICoachErrorMessage={args.showGenAICoachErrorMessage}
          defaultExpanded={!!args.defaultExpanded}
          additionalActions={args.additionalActions}
          showUtilityNotification={args.showUtilityNotification}
          showPersistentUtilityExpand={args.showPersistentUtilityExpand}
        />
      }
    />
  );
};

CaseViewDemo.args = {
  caseId: 'C-123456',
  icon: 'user-solid',
  heading: 'Constellation',
  subheading: 'C-123456',
  parentCases: false,
  promotedActions: 1,
  summaryFields: 'All',
  stages: true,
  tasks: true,
  taskCount: 4,
  predictions: true,
  attachments: true,
  stakeholders: true,
  casehierarchy: true,
  followers: true,
  tags: true,
  persistentUtility: false,
  banner: false,
  headingLength: 'short',
  defaultExpanded: true,
  additionalActions: true,
  enableGenAICoach: true,
  showGenAICoachErrorMessage: false,
  showUtilityNotification: false,
  showPersistentUtilityExpand: true
};

CaseViewDemo.argTypes = {
  caseId: { control: { type: 'text' } },
  icon: { control: { type: 'text' } },
  heading: { control: { type: 'text' } },
  subheading: { control: { type: 'text' } },
  summaryFields: {
    control: 'radio',
    options: ['All', 'Primary only', 'Secondary only']
  },
  stages: { control: { type: 'boolean' } },
  tasks: { control: { type: 'boolean' } },
  taskCount: { control: { type: 'number' } },
  parentCases: { control: { type: 'boolean' } },
  predictions: { control: { type: 'boolean' } },
  attachments: { control: { type: 'boolean' } },
  stakeholders: { control: { type: 'boolean' } },
  casehierarchy: { control: { type: 'boolean' } },
  followers: { control: { type: 'boolean' } },
  tags: { control: { type: 'boolean' } },
  persistentUtility: { control: { type: 'boolean' } },
  banner: { control: { type: 'boolean' } },
  promotedActions: { control: { type: 'select' }, options: [0, 1, 2, 3, 4, 5] },
  headingLength: { control: { type: 'select' }, options: ['short', 'medium', 'long'] },
  defaultExpanded: { control: { type: 'boolean' } },
  additionalActions: { control: { type: 'boolean' } },
  enableGenAICoach: { control: { type: 'boolean' } },
  showGenAICoachErrorMessage: { control: { type: 'boolean' } },
  showUtilityNotification: { control: { type: 'boolean' } },
  showPersistentUtilityExpand: { control: { type: 'boolean' } }
};
